module.exports = __webpack_public_path__ + "static/media/pacific.b389ed2b.png";